module.exports = __webpack_public_path__ + "img/sg2.b80b5810.png";